import { render } from "./GetStartedPopup.vue?vue&type=template&id=40b52efa&scoped=true&bindings={\"show\":\"props\",\"showCopied\":\"data\",\"close\":\"options\",\"copyHashtag\":\"options\"}"
import script from "./GetStartedPopup.vue?vue&type=script&lang=js"
export * from "./GetStartedPopup.vue?vue&type=script&lang=js"

import "./GetStartedPopup.vue?vue&type=style&index=0&id=40b52efa&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-40b52efa"

export default script